import NavMenuItem from "../ui/nav-menu-item";
import { useState, useContext } from "react";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import { useRouter } from "next/router";
import NavSection from "./nav-section";
import DomainContext from "../../contexts/domain-context";
import Tooltips from "../ui/tooltip";
import DynamicIcon from "../ui/dynamic-icon";
import SearchableInputContext from "../../contexts/searchable-input-context";
import { getCommandKey } from "../../lib/utils";
import { useTranslations } from "next-intl";
import { isPegInstalled } from "../../lib/auth";
import GeneralSearchModal from "./general-search-modal";

const NavMenuItems = () => {
  const t = useTranslations('nav');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({
    workpegAI: false,
    dashboard: false,
  });
  const router = useRouter();
  const userCtx = useContext(UserContext);
  const user = userCtx.user;
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;
  const { checkIfUserHasEmail } = useContext(DomainContext);
  const { toggleSearchModal, isSearchModalOpen } = useContext(SearchableInputContext);
  
  const isFeatureEnabled = window.location.hostname.startsWith('local') || typeof window !== 'undefined' && (window.location.hostname.startsWith('staging'));





  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDropdown = (dropdown) => {
    setDropdownStates((prevState) => ({
      ...prevState,
      [dropdown]: !prevState[dropdown],
    }));
  }
  if (checkIfUserHasEmail() === false) {
    return (
      <div className="grid gap-[4px] content-start max-h-[70dvh] overflow-y-scroll scrollbar-none">
        <span className="px-[27px] text-[12px] custom-text-grey-800  poppins-regular">
          {t('getStarted')}
        </span>
        <NavMenuItem icon="badge-check" href="/onboarding">
          {t('onboard')}
        </NavMenuItem>
      </div>
    );
  }
// console.log(isSearchModalOpen, "isSearchModalOpen");

  return (
    <>
    <div className="grid gap-[4px] content-start max-h-[100vh]">
      <NavSection>
        <Tooltips position="right" content={isFeatureEnabled ? 'Search': "This feature is coming soon"} command={isFeatureEnabled ? getCommandKey('search') : ''}>
          <div
            onClick={isFeatureEnabled ? toggleSearchModal : null}
            className={`hover:custom-bg-grey-50 grid grid-flow-col justify-start items-center ${isFeatureEnabled ? 'cursor-pointer' : 'cursor-not-allowed'} w-full text-[12px] h-[35px] px-[27px] gap-[12px] rounded-[8px] custom-text-grey-800 `}>
            <DynamicIcon name='search' size={16} color="custom-text-grey-900" />
            <span className={`custom-text-grey-500  poppins-medium text-[12px] tracking-[0.5px]`}>{t('search')}</span>
          </div>
        </Tooltips>
        <NavMenuItem icon="sparkles" href="/chats" history>
          {t('workpegAI')}
        </NavMenuItem>
      </NavSection>
      {/* {isPegInstalled() == true &&  */}
      <NavSection>
        <NavMenuItem icon="inbox" href="/inbox">
          {t('inbox')}
        </NavMenuItem>
        <NavMenuItem icon="send" href="/sent">
          {t('sent')} 
        </NavMenuItem>
        <NavMenuItem icon="contact" href="/contacts">
          {t('contacts')}
        </NavMenuItem>
      </NavSection>
    </div>
    <GeneralSearchModal toggleModal={toggleSearchModal} isOpen={isSearchModalOpen}/>
    </>
  );
};

export default NavMenuItems;
